import {
  DefaultTheme,
  FlattenSimpleInterpolation,
  css,
} from 'styled-components/macro';
import { StyledBadgeProps } from './badge.types';

type VariantMap = Record<
  StyledBadgeProps['$variant'],
  FlattenSimpleInterpolation
>;

type ColorsMap = Record<StyledBadgeProps['$mode'], VariantMap>;

const createPallete = (
  theme: DefaultTheme,
  colors: Pick<
    DefaultTheme['semantic']['indication']['info'],
    'bgMain' | 'bg' | 'text'
  >
): VariantMap => ({
  main: css`
    background-color: ${colors.bgMain};
    color: ${theme.semantic.indication.textOnMain};
  `,
  secondary: css`
    background-color: ${colors.bg};
    color: ${colors.text};
  `,
  tertiary: css`
    background-color: ${theme.semantic.indication.bgTertiary};
    color: ${colors.text};
  `,
  ghost: css`
    background-color: transparent;
    color: ${colors.text};

    &[data-disabled='true'] {
      background-color: transparent;
    }
  `,
});

export const colorsMap = (theme: DefaultTheme): ColorsMap => ({
  primary: createPallete(theme, theme.semantic.indication.info),
  gray: createPallete(theme, theme.semantic.indication.neutral),
  orange: createPallete(theme, theme.semantic.indication.warning),
  red: createPallete(theme, theme.semantic.indication.error),
  green: createPallete(theme, theme.semantic.indication.success),
  purple: createPallete(theme, theme.semantic.indication.super),
});
